import { useMemo } from "react";
import { Link } from "react-router-dom";
import classes from "./megaMenu.module.css";
import Slider from "react-slick";
import Shimmer from "../../../../components/Shimmer";

const MegaMenu = ({ categoryData }) => {
  const settings = useMemo(
    () => ({
      dots: false,
      arrows: true,
      autoplay: true,
      speed: 300,
      slidesToShow: 7,
      slidesToScroll: 1,
      lazyload: "ondemand",
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            infinite: categoryData?.categories?.items?.length > 7,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            infinite: categoryData?.categories?.items?.length > 4,
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 449,
          settings: {
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    }),
    [categoryData?.categories?.items?.length]
  );

  const memoizedSlides = useMemo(() => {
    return categoryData?.categories?.items?.map((Category) => (
      <div className={classes.item} key={Category.id}>
        <Link to={`/category/${Category.url_path}`} state={{ id: Category.id }}>
          {Category.image1 ? (
            <img
              src={Category.image1}
              alt={Category.name}
              width={100}
              height={100}
              loading="lazy"
            />
          ) : (
            <div className={classes.placeholderRoot}>
              <span className={classes.svgPlaceholder} />
            </div>
          )}
          <p className={classes.categoryName}>{Category.name}</p>
        </Link>
      </div>
    ));
  }, [categoryData?.categories?.items?.length]);

  if (!categoryData?.categories?.items?.length) {
    return <Shimmer width={"100%"} height={"165px"} />;
  }

  return (
    <section className="pt-2 pb-2 Mega_Menu">
      <div className="container">
        <div className={classes.category}>
          <Slider {...settings}>{memoizedSlides}</Slider>
        </div>
      </div>
    </section>
  );
};

export default MegaMenu;
